
import { defineComponent } from "vue";
import { delcomment, commentindex,commentfavorites } from "@/views/post/api/index.ts";
import editor from "@/views/post/components/editor.vue";
import pagination from "@/views/post/components/pagination.vue";
import swiper from "@/views/post/components/swiper/swiper.vue";
import toast from "@/views/post/components/toast.vue";
export default defineComponent({
  components: {
    editor,
    pagination,
    swiper,
    toast
  },
  props: {
    comment: {
      type: Array
    },
    post_id: {
      type: String
    },
    comment_cnt: {
      type: Number
    },
    index: {
      type: Number
    },
  },
  data(){
    return {
      uid: parseInt((window.globalData as any).uid || 0),
      commentList: this.comment,
      pingIndex: -1,
      item_id: "",
      comment_id:"",
      limit: 10,
      page: 1,
      total: this.comment_cnt,
      imglist:[],
      imglistindex:0
    }
  },
  
  setup() {
    const gohome: (e: any) => void = (e: any) => {
      const uid = e.currentTarget.dataset.uid
      if(!Number(uid)) return
      const certified_type = e.currentTarget.dataset.certified_type
      const certified_id = e.currentTarget.dataset.certified_id
      let url = ""
      if(certified_type == 2){
        url = `/hospital/${certified_id}/`
      } else if(certified_type == 3){
        url = `/doctor/${certified_id}/zhuye/`
      } else {
        url = `/u${uid}`
      }
      window.open(`${window.location.origin}${url}`)
    };
    return {
      gohome
    };
  },
  watch:{
    comment: {
      handler() {
        this.commentList = this.comment
      }
    },
    comment_cnt:{
      handler() {
        this.total = this.comment_cnt
      }
    }
  },
  methods:{
    del(e: any){
      if(confirm('确定要删除吗') == true){
        const comment_id = e.currentTarget.dataset.comment_id
        const item_id = e.currentTarget.dataset.item_id
        delcomment({
          item_id,
          comment_id,
          class_id: 8,
          primary_id: this.post_id,
        }).then(({errorCode,errorMsg})=>{
          if(errorCode == 0){
          this.pingIndex = -1
          commentindex({
            page: 1,
            num: 10,
            item_id,
            class_id: 8,
          }).then(({errorCode,errorMsg,responseData}) => {
            if (errorCode === 0) {
              this.commentList = responseData.list
            } else {
              (this.$refs.toast as any).show(errorMsg)
            }
          })
          } else {
            (this.$refs.toast as any).show(errorMsg)
          }
        })
      }
    },
    showPinglun(e: any){
      this.pingIndex = e.currentTarget.dataset.index
      this.comment_id = e.currentTarget.dataset.comment_id
      this.item_id = e.currentTarget.dataset.item_id
    },
    getpageupdate(e = 1){
      this.pingIndex = -1
      this.page = e
      commentindex({
        page: this.page,
        num: this.limit,
        item_id: this.item_id,
        class_id: 8,
      }).then(({errorCode,errorMsg,responseData}) => {
        if (errorCode === 0) {
          this.commentList = responseData.list
          //this.total = responseData.total
          const top = ((document.querySelectorAll(".comment>.list") as any)[(this.index as any)] as any ).offsetTop - 100;
          document.body.scrollTop = top
          document.documentElement.scrollTop = top
        } else {
          (this.$refs.toast as any).show(errorMsg)
        }
      })
    },
    getupdate(comment: Array<any>){
      (this.commentList as Array<any>).splice(this.pingIndex * 1 + 1,0,comment)
      this.pingIndex = -1;
    },
    zan(e: any){
      const comment_id = e.currentTarget.dataset.comment_id
      const reply_id = e.currentTarget.dataset.reply_id
      const index = e.currentTarget.dataset.index
      if (this.uid === 0) {
        window.sy.login.popup()
        return
      }
      commentfavorites({
        post_id: this.post_id,
        reply_id,
        type: 1,
        comment_id
      }).then(({errorCode,errorMsg}) => {
        if (errorCode === 0) {
          (this.commentList as any)[index].is_favor = 1;
          (this.commentList as any)[index].ding_cnt = parseInt((this.commentList as any)[index].ding_cnt) + 1
        } else {
          (this.$refs.toast as any).show(errorMsg)
        }
      })
    },
    shoImg(e: any){
      const index = e.currentTarget.dataset.index
      this.imglistindex = e.currentTarget.dataset.i
      const temp = (this.commentList as any)[index].comment_imgs
      this.imglist = temp
    },
    close(){
      this.imglist = []
    }
  },
  created(){
    this.item_id = (this.commentList as any)[0] ? (this.commentList as any)[0].item_id : ""
  }
});
